module.exports = __webpack_public_path__ + "img/684649988.904e17ea.svg";